module.exports = __webpack_public_path__ + "img/heim.ea08ee4e.jpg";